import { useDepotsQuery } from "@evr/apis/depot";
import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectDepotsQuery } from "@evr/store/slices/depot";

export const useGetDepotsQuery = () => {
  const queryParams = useAppSelector(selectDepotsQuery);
  return useDepotsQuery(queryParams);
};
